import Share from 'ninelines-sharing';

document.querySelectorAll('.sharing__button[data-social]').forEach((button) => {
	button.addEventListener('click', (e) => {
		const url = location.origin + location.pathname;

		// eslint-disable-next-line default-case
		switch (e.currentTarget.dataset.social) {
			case 'facebook':
				Share.facebook(url);
				break;
			case 'vk':
				Share.vk(url);
				break;
			case 'twitter':
				Share.twitter(url);
				break;
			case 'ok':
				Share.ok(url);
				break;
			case 'telegram':
				Share.telegram(url);
				break;
		}
	});
});
